export default [
  {
    path: '/lead-details',
    name: 'leadDetails',
    component: () => import('@/views/pages/leadDetails/LeadDetails.vue'),
  }
]